(function ($) {
    "use strict";

    const predictiveSearchSelector =
        "[data-predictive-search-component]";

    const predictiveSearchInputSelector =
        "[data-predictive-search-input]";

    const predictiveSearchResultsSelector =
        "[data-predictive-search]";

    const predictiveSearchListSelector =
        "[data-predictive-search-list]";

    const predictiveSearchEndpoint =
        "/api/sitecore/SiteSearch/Predictive";

    const predictiveSearchDatasourceIdAttribute =
        "data-predictive-search-datasource-id";

    const minimumCharacters = 2;
    const debounceDelay = 300;
    const resizeDebounceDelay = 200;
    const visibleItemCount = 5;
    const heightRoundingCompensation = 1;

    $(predictiveSearchSelector).each(function () {
        const $component = $(this);

        const predictiveSearchDatasourceId =
            $component.attr(
                predictiveSearchDatasourceIdAttribute
            ) || "";

        const $input = $component
            .find(predictiveSearchInputSelector)
            .first();

        const $results = $component
            .find(predictiveSearchResultsSelector)
            .first();

        const $list = $component
            .find(predictiveSearchListSelector)
            .first();

        if (
            !$input.length ||
            !$results.length ||
            !$list.length
        ) {
            return;
        }

        let activeRequest = null;
        let activeRequestSearchTerm = "";
        let lastRenderedSearchTerm = "";
        let activeResultIndex = -1;

        /**
         * Returns all currently rendered predictive result links.
         */
        function getPredictiveResultLinks() {
            return $list.find("a");
        }

        /**
         * Highlights matching words in the predictive result titles.
         *
         * This only changes the visual presentation of matching text. It does
         * not filter, hide, reorder, or otherwise modify the returned results.
         */
        function markPredictiveResultMatches(searchTerm) {
            const resultLinks =
                getPredictiveResultLinks().get();

            if (
                !resultLinks.length ||
                typeof Mark === "undefined"
            ) {
                return;
            }

            const instance =
                new Mark(resultLinks);

            instance.unmark({
                done: function () {
                    if (!searchTerm) {
                        return;
                    }

                    instance.mark(
                        searchTerm,
                        {
                            separateWordSearch: true
                        }
                    );
                }
            });
        }

        /**
         * Clears the current keyboard-highlighted result.
         */
        function clearActivePredictiveResult() {
            getPredictiveResultLinks()
                .removeClass("is-active")
                .removeAttr("aria-current");

            activeResultIndex = -1;
        }

        /**
         * Highlights the result at the supplied index.
         *
         * Moving beyond either end wraps to the opposite end.
         */
        function setActivePredictiveResult(index) {
            const $links =
                getPredictiveResultLinks();

            if (!$links.length) {
                clearActivePredictiveResult();
                return;
            }

            if (index < 0) {
                index = $links.length - 1;
            }

            if (index >= $links.length) {
                index = 0;
            }

            clearActivePredictiveResult();

            activeResultIndex =
                index;

            const $activeLink =
                $links.eq(activeResultIndex);

            $activeLink
                .addClass("is-active")
                .attr("aria-current", "true");

            const activeLinkElement =
                $activeLink.get(0);

            if (
                activeLinkElement &&
                typeof activeLinkElement.scrollIntoView ===
                "function"
            ) {
                activeLinkElement.scrollIntoView({
                    block: "nearest"
                });
            }
        }

        /**
         * Hides the predictive-search dropdown.
         *
         * Results are preserved by default so they can be shown again when
         * the user returns focus to an unchanged input.
         *
         * Pass true to remove the rendered results and clear the cached term.
         */
        function closePredictiveSearch(clearResults) {
            clearActivePredictiveResult();

            if (clearResults === true) {
                $list.empty();
                $results.css("max-height", "");
                lastRenderedSearchTerm = "";
            }

            $results.prop("hidden", true);
            $input.attr("aria-expanded", "false");
        }

        /**
         * Displays predictive results already rendered in the DOM.
         */
        function showPredictiveSearch() {
            if (!$list.children().length) {
                return;
            }

            /*
             * The dropdown must be visible before measuring its children.
             */
            $results.prop("hidden", false);

            setPredictiveSearchMaxHeight();

            $input.attr("aria-expanded", "true");
        }

        /**
         * Returns true when the rendered results were generated for the
         * supplied search term.
         */
        function hasCachedResults(searchTerm) {
            return (
                $list.children().length > 0 &&
                lastRenderedSearchTerm === searchTerm
            );
        }

        /**
         * Cancels the current API request, if one is running.
         */
        function cancelActiveRequest() {
            if (!activeRequest) {
                return;
            }

            activeRequest.abort();
            activeRequest = null;
            activeRequestSearchTerm = "";
        }

        /**
         * Sets the dropdown maximum height to the rendered height of its first
         * five results, including list padding and borders.
         */
        function setPredictiveSearchMaxHeight() {
            const $allItems =
                $list.children();

            if (!$allItems.length) {
                $results.css("max-height", "");
                return;
            }

            /*
             * Temporarily hide every item after the fifth so the list's own
             * measured height naturally includes its padding and borders.
             */
            const $overflowItems =
                $allItems.slice(visibleItemCount);

            $overflowItems.hide();

            const maximumHeight =
                $list.outerHeight(true);

            $overflowItems.show();

            if (maximumHeight > 0) {
                $results.css(
                    "max-height",
                    (
                        maximumHeight +
                        heightRoundingCompensation
                    ) + "px"
                );
            } else {
                $results.css("max-height", "");
            }
        }

        /**
         * Creates and displays predictive result links returned by the API.
         */
        function renderPredictiveResults(
            results,
            searchTerm
        ) {
            $list.empty();
            clearActivePredictiveResult();

            if (
                !Array.isArray(results) ||
                results.length === 0
            ) {
                closePredictiveSearch(true);
                return;
            }

            results.forEach(function (result) {
                if (
                    !result ||
                    !result.Title ||
                    !result.Url
                ) {
                    return;
                }

                const $resultItem =
                    $("<div>");

                const $link = $("<a>", {
                    href: result.Url,
                    text: result.Title
                });

                if (
                    result.Score !== null &&
                    typeof result.Score !== "undefined"
                ) {
                    $resultItem.attr(
                        "data-score",
                        result.Score
                    );
                }

                $resultItem.append($link);
                $list.append($resultItem);
            });

            if (!$list.children().length) {
                closePredictiveSearch(true);
                return;
            }

            /*
             * Highlight each matching word from the user's search term in the
             * rendered titles without changing which results are displayed.
             */
            markPredictiveResultMatches(
                searchTerm
            );

            lastRenderedSearchTerm =
                searchTerm;

            showPredictiveSearch();
        }

        /**
         * Requests predictive results from the same service used by the full
         * search-results page.
         */
        function loadPredictiveResults(searchTerm) {
            if (
                activeRequest &&
                activeRequestSearchTerm === searchTerm
            ) {
                return;
            }

            cancelActiveRequest();

            activeRequestSearchTerm =
                searchTerm;

            const request = $.ajax({
                url: predictiveSearchEndpoint,
                method: "GET",
                dataType: "json",
                cache: false,
                data: {
                    searchterm: searchTerm,
                    datasourceid:
                        predictiveSearchDatasourceId
                }
            });

            activeRequest =
                request;

            request
                .done(function (results) {
                    if (
                        $input.val().trim() !== searchTerm
                    ) {
                        return;
                    }

                    renderPredictiveResults(
                        results,
                        searchTerm
                    );
                })
                .fail(function (xhr, status) {
                    if (status !== "abort") {
                        closePredictiveSearch(true);
                    }
                })
                .always(function () {
                    if (activeRequest === request) {
                        activeRequest = null;
                        activeRequestSearchTerm = "";
                    }
                });
        }

        /*
 * Immediately close predictive search when the input is cleared or falls
 * below the minimum character count. API requests remain debounced below.
 */
        $input.on("input", function () {
            const searchTerm =
                $input.val().trim();

            if (
                searchTerm.length <
                minimumCharacters
            ) {
                cancelActiveRequest();
                closePredictiveSearch(true);
            }
        });

        /**
         * Waits until the user pauses typing before requesting results.
         */
        $input.on(
            "input",
            debounce(function () {
                const searchTerm =
                    $input.val().trim();

                if (
                    searchTerm.length <
                    minimumCharacters
                ) {
                    return;
                }

                clearActivePredictiveResult();

                loadPredictiveResults(
                    searchTerm
                );
            }, debounceDelay)
        );

        /**
         * Shows cached results when the user returns to an unchanged input.
         *
         * If the page loaded with a query-string value, the API is called the
         * first time the input receives focus.
         */
        $input.on("focus", function () {
            const searchTerm =
                $input.val().trim();

            if (
                searchTerm.length <
                minimumCharacters
            ) {
                return;
            }

            if (hasCachedResults(searchTerm)) {
                showPredictiveSearch();
                return;
            }

            loadPredictiveResults(
                searchTerm
            );
        });

        /**
         * Supports keyboard navigation while focus remains in the input.
         *
         * ArrowDown moves forward.
         * ArrowUp moves backward.
         * Enter activates the highlighted link.
         * Escape hides the dropdown.
         */
        $input.on("keydown", function (event) {
            const searchTerm =
                $input.val().trim();

            if (event.key === "Escape") {
                closePredictiveSearch(false);
                return;
            }

            if (
                event.key !== "ArrowDown" &&
                event.key !== "ArrowUp" &&
                event.key !== "Enter"
            ) {
                return;
            }

            /*
             * If the dropdown is hidden, ArrowUp or ArrowDown can reopen cached
             * results or trigger a request when no cached results exist.
             */
            if ($results.prop("hidden")) {
                if (
                    event.key === "Enter" ||
                    searchTerm.length <
                    minimumCharacters
                ) {
                    return;
                }

                event.preventDefault();

                if (hasCachedResults(searchTerm)) {
                    showPredictiveSearch();
                } else {
                    loadPredictiveResults(
                        searchTerm
                    );
                }

                return;
            }

            const $links =
                getPredictiveResultLinks();

            if (!$links.length) {
                return;
            }

            if (event.key === "ArrowDown") {
                event.preventDefault();

                setActivePredictiveResult(
                    activeResultIndex + 1
                );

                return;
            }

            if (event.key === "ArrowUp") {
                event.preventDefault();

                setActivePredictiveResult(
                    activeResultIndex - 1
                );

                return;
            }

            /*
             * Enter submits the normal form when no result is highlighted.
             * When a result is highlighted, it activates that link instead.
             */
            if (
                event.key === "Enter" &&
                activeResultIndex >= 0
            ) {
                event.preventDefault();

                const activeLink =
                    $links.get(
                        activeResultIndex
                    );

                if (activeLink) {
                    activeLink.click();
                }
            }
        });

        /*
         * Clicking outside hides the dropdown while preserving cached results.
         */
        $(document).on(
            "click",
            function (event) {
                if (
                    !$component[0].contains(
                        event.target
                    )
                ) {
                    closePredictiveSearch(false);
                }
            }
        );

        /*
         * Recalculate the dropdown height after resizing because titles may
         * wrap differently when the available width changes.
         */
        $(window).on(
            "resize",
            debounce(function () {
                if (
                    !$results.prop("hidden") &&
                    $list.children().length
                ) {
                    setPredictiveSearchMaxHeight();
                }
            }, resizeDebounceDelay)
        );
    });
})(jQuery);